export default "__VITE_ASSET__B$qb$n2l__"